export const STORE = {
  CLUSTER:    'cluster',
  RANCHER:    'rancher',
  MANAGEMENT: 'management',
};

export const BLANK_CLUSTER = '_';
